export default __webpack_public_path__ + "static/media/keno.6276adfe.webp";